import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AllUPI, Bottles, Card, Charger, Mobile, MyLocation, Netbanking, Notes, QRG, StarWhite, UPI, Wallet, Watch } from '../../assests/ExportImageIcon'
import { BUS_RESULT } from './busList/BusResults'

// Static placeholder — no bus payment API exists yet, so payment methods and
// the fare summary below are hardcoded to match the reference design exactly
// (same approach as bus.jsx/findbus.jsx/busBookingDetail.jsx). Once a bus API
// is available, this can be wired up the same way flight/payment.jsx or
// venue/venuePayment.jsx are (checkout + verify, real fare breakup, etc).
const PAYMENT_METHODS = [
    { key: 'upi', icon: UPI, title: 'UPI', subtitle: 'Google Pay, PhonePe, Paytm' },
    { key: 'card', icon: Card, title: 'Credit / Debit Card', subtitle: 'Visa, Mastercard, Rupay, Amex' },
    { key: 'netbanking', icon: Netbanking, title: 'Net Banking', subtitle: 'All major banks supported' },
    { key: 'wallet', icon: Wallet, title: 'Wallets', subtitle: 'Paytm, PhonePe, Amazon Pay' },
]

const BusPayment = () => {
    const navigate = useNavigate()
    const [fareSummaryOpen, setFareSummaryOpen] = useState(true)
    const [activeMethod, setActiveMethod] = useState('upi')
    const [savedCardSelected, setSavedCardSelected] = useState(true)
    const [paying, setPaying] = useState(false)
    const [secondsLeft, setSecondsLeft] = useState(9 * 60 + 29)

    useEffect(() => {
        if (secondsLeft <= 0) return
        const timerId = setTimeout(() => setSecondsLeft((prev) => prev - 1), 1000)
        return () => clearTimeout(timerId)
    }, [secondsLeft])

    const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0')
    const seconds = String(secondsLeft % 60).padStart(2, '0')

    const handlePayClick = () => {
        if (paying) return
        setPaying(true)
        // No real payment gateway wired up yet — this just advances to the
        // (also static) confirmation page, matching this vertical's current
        // no-API placeholder pattern.
        navigate('/bus-booking-confirm')
    }

    return (
        <section className='paymentPart commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='time bgWhite paddingCommon20 borderRadius40 commonBorder'>
                            <span className='timePill'>
                                <img src={Watch} alt="" />
                                {minutes} : {seconds}
                            </span>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='paymentSec allBookingDetail'>
                            <div className='onlineCrad allBokkingInfo'>
                                <div className='paymentMethodBox'>
                                    <div className='paymentMethodList'>
                                        {PAYMENT_METHODS.map((method) => (
                                            <div
                                                key={method.key}
                                                className={`paymentMethodItem ${activeMethod === method.key ? 'active' : ''}`}
                                                onClick={() => setActiveMethod(method.key)}
                                            >
                                                <span className='paymentMethodIcon'>
                                                    <img src={method.icon} alt={method.title} />
                                                </span>
                                                <div>
                                                    <div className='paymentMethodTitle'>{method.title}</div>
                                                    <div className='paymentMethodSub'>{method.subtitle}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className='paymentMethodPanel'>
                                        {activeMethod === 'upi' && (
                                            <>
                                                <div className='paymentQrHead'>
                                                    <div className='paymentQrText'>
                                                        <div className='bsSectionTitle'>Scan &amp; Pay with UPI</div>
                                                        <p className='paymentQrDesc'>
                                                            Open any UPI or banking app on your phone
                                                            <br />
                                                            Scan the QR code to pay
                                                        </p>
                                                    </div>
                                                    <img src={Mobile} alt="" className='paymentQrPhone' />
                                                    <div className='paymentQrCodeWrap'>
                                                        <img src={QRG} alt="Scan to pay" className='paymentQrCode' />
                                                        <button type='button' className='paymentGenerateQrBtn'>Generate QR</button>
                                                    </div>
                                                </div>

                                                <img src={AllUPI} alt="Supported UPI apps" className='paymentUpiApps' />
                                            </>
                                        )}

                                        {activeMethod === 'card' && (
                                            <div className='bsSectionTitle'>Add a new Credit / Debit Card</div>
                                        )}

                                        {activeMethod === 'netbanking' && (
                                            <div className='bsSectionTitle'>Select your bank</div>
                                        )}

                                        {activeMethod === 'wallet' && (
                                            <div className='bsSectionTitle'>Select a wallet</div>
                                        )}

                                        <div className='paymentSavedMethod' onClick={() => setSavedCardSelected(!savedCardSelected)}>
                                            <span className='resultCard__logo'>
                                                <img src={Card} alt="Kotak Mahindra Bank" />
                                            </span>
                                            <div className='paymentSavedMethodInfo'>
                                                <div className='resultCard__airlineName'>Kotak Mahindra Bank</div>
                                                <div className='paymentSavedMethodSub'>
                                                    Credit Card....2269 <span>RuPay</span>
                                                </div>
                                            </div>
                                            <span className={`paymentRadio ${savedCardSelected ? 'checked' : ''}`} />
                                        </div>

                                        <div className='paymentInfoBanner'>
                                            <img src={Notes} alt="" />
                                            This card does not require a CVV
                                        </div>

                                        <button type='button' className='commonBtn w-100' disabled={paying} onClick={handlePayClick}>
                                            {paying ? 'Processing...' : 'Securely Pay ₹4,549'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='paymentSidebar bookingSidebar'>
                                <div className='bsSection bgWhite paddingCommon20 borderRadius20 commonBorder'>
                                    <div className='fareDetailsHead' onClick={() => setFareSummaryOpen(!fareSummaryOpen)}>
                                        <div className='bsSectionTitle'>Fare Summary</div>
                                        <span className={`fareCollapseIcon ${fareSummaryOpen ? 'open' : ''}`}>&#8963;</span>
                                    </div>

                                    {fareSummaryOpen && (
                                        <div className='bsFareRow bsFareRow--total mt-3'>
                                            <span>Amount To Be Paid</span>
                                            <span>₹4,549</span>
                                        </div>
                                    )}
                                </div>

                                <div className='bsSection'>
                                    <div className='bsBox'>
                                        <div className='resultCard__airline'>
                                            <div>
                                                <div className='resultCard__airlineName'>{BUS_RESULT.operator}</div>
                                                <div className='resultCard__flightNo'>{BUS_RESULT.busType}</div>
                                            </div>
                                        </div>

                                        <div className='busResultCard__rating mt-2'>
                                            <span className='hotelCard__ratingBadge'>
                                                <img src={StarWhite} alt="" /> {BUS_RESULT.rating}
                                            </span>
                                            <span className='busResultCard__reviews'>({BUS_RESULT.reviews})</span>
                                        </div>

                                        <div className='busResultCard__amenities mt-2'>
                                            <img src={Charger} alt="" />
                                            <img src={MyLocation} alt="" />
                                            <img src={Bottles} alt="" />
                                        </div>

                                        <div className='bsFareDivider' />

                                        <div className='bsFareRow'>
                                            <span>Departure:</span>
                                            <span>{BUS_RESULT.departureTime}</span>
                                        </div>
                                        <div className='bsFareRow'>
                                            <span>Arrival:</span>
                                            <span>{BUS_RESULT.arrivalTime}</span>
                                        </div>
                                        <div className='bsFareRow'>
                                            <span>Duration:</span>
                                            <span>{BUS_RESULT.duration}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BusPayment
